const en = {
    9000001: "2023 Christmas Trophy",
    9000002: "SuperEx Futures Championships",
    9000003: "Win 30,000 USDT in competition prize",
    9000004: "Number of Participants",
    9000005: "Unlocked Reward Pool (USDT)",
    9000006: "Trading Volume Ranking Qualifier",
    9000007: "Profit Rate Ranking Qualifying Competition",
    9000008: "Profit Ranking Qualifying Competition ",
    9000009: `Trading Volume Ranking Competition: Unlock the highest prize of <span style="color: #ffc72b;">20,000</span> USDT bonus pool. `,
    9000010: "According to the number of participants, the larger the number of participants, the larger the prize pool will be unlocked, up to 20,000USDT. ",
    9000011: "Reward Amount",
    9000012: "Updated at 10:00 (UTC) every day during the event",
    9000013: "Reward estimate ",
    9000014: "Cumulative Futures trading volume",
    9000015: "Reward Rules",
    9000016: "According to the number of participants, the larger the number of participants, the larger the prize pool will be unlocked, up to 20,000USDT. ",
    9000017: "Reward Amount (USDT)",
    9000018: "Event Profit Rate Ranking",
    9000019: "Register",
    9000020: "Event Profit Ranking",
    9000021: "Ended",
    9000022: `Profit Rate Ranking Contest - Enjoy <span style="color: #ffc72b;">{moneyPond}</span> USDT Bonus`,
    9000023: `Profit Ranking Competition - Enjoy <span style="color: #ffc72b;">{moneyPond}</span> USDT Bonus  `,
    9000024: "Cumulative Futures profit rate",
    9000025: "Futures Total Profits ",
    9000026: "Upcoming",
    9000027: "The top 50 participants in the Profit Ranking Competition will be rewarded. For details, please refer to the Ranking Reward Rules to get the rewards.",
    9000028: "The top 50 participants in terms of profitability will be rewarded, please refer to Trading Ranking Reward Rules to get the reward. ",
    9000029: "Event Trading Volume Ranking",
    9000030: "Registration successful",
    9000031: "Download the App",
    9000032: "Back to Home",

    //合约交易积分
    9100001: 'Save Points',
    9100002: 'Get Airdrop',
    9100003: 'Redeem Rewards',
    9100004: 'Points balance',
    9100005: 'Details',
    9100006: 'Sign-in points',
    9100007: 'Trading Points',
    9100008: 'Invitation points',
    9100009: 'Bonus points',
    9100010: 'Lucky draw',
    9100011: 'Get points',
    9100012: 'Points rules',
    9100013: 'Points details',
    9100014: 'You need to register to participate in this event. Click to register',
    9100015: 'Have traded for {day} consecutive days and earned {num} points',
    9100016: 'Points earned today {num}',
    9100017: 'Points prize pool',
    9100018: 'Each lucky draw consumes {point} points, and the maximum of {num} lucky draws times per day can be drawn.',
    9100019: 'Number of lucky draws today',
    9100020: 'User',
    9100021: 'Points',
    9100022: 'Points balance is insufficient',
    9100023: 'Points balance is insufficient. Please get points before participating in the lucky draw.',
    9100024: 'Number of lucky draws reached its limit!',
    9100025: 'Number of lucky draws for today reached its limit. Try again tomorrow.',
    9100026: 'How to get points',
    9100027: 'Register to participate in the Futures trading point-earning activity to earn points.',
    9100028: 'Successful registration',
    9100029: 'You have signed up to participate in the Futures trading activity to earn points. Go and trade to earn more points (you will no longer enjoy the commission and cashback rewards)',
    9100030: 'After canceling your registration, you will no longer receive points. Are you sure you want to cancel your registration?',
    9100031: 'Trading Points Activity Center',
    9100032: 'Get points',
    9100033: 'You need to register to participate in this event. Click to register',
    9100034: 'You can earn points by trading Futures continuously',
    9100035: 'Users can earn points for all Futures tradings',
    9100036: 'Leaderboard points',
    9100037: 'Top five users in the daily trading rankings will receive additional bonus points',
    9100038: 'Invited users receive points and the inviter can receive bonus points.',
    9100039: '{guy} Already won<span style="color:#D9A31A"> {num} points!</span>',
    9100040: 'Try Lucky Draw Now!',
    9100041: 'Congratulations on getting',
    9100042: 'All types',
    9100043: 'Stay on this page',
    9100044: 'Register to particpate',
    9100045: 'Continue trading',
    9100046: 'There are no ongoing events at the moment. Please stay tuned for updates...',
    9100047: 'and exchange them for SCS tokens',
    9100048: '',
    9100049: '',

    9100050: 'Dates',
    9100051: 'Select start date',
    9100052: 'Select end date',
    9100053: 'to',
    9100054: 'Type',

    9100055: 'Points earned = trading volume * 1% (the difficulty will be further adjusted as the total trading volume of the platform increases)',
    9100056: 'For example: the user uses a position with a margin of 100 USDT*100X=10000 USDT',
    9100057: 'Then you only need a deposit of 100 USDT to get 100 points',
    9100058: 'Trading points are the only way to obtain the platform token SCS',
    9100059: 'Extra bonus points = total points for the day * ranking reward ratio',
    9100060: 'Ranking',
    9100061: 'First place',
    9100062: 'Second place',
    9100063: 'Third place',
    9100064: 'Fourth place',
    9100065: 'Fifth place',
    9100066: 'Invited users receive points and the inviter can receive bonus points.',
    9100067: 'Level factor ',
    9100068: 'Calculation formula: referral points obtained = points obtained by the invitee * level coefficient',
    9100069: 'The level coefficient will be adjusted according to the actual situation',
    9100070: 'For example: User B participates in a points activity, and its inviter is User A, and the number of invitations from User A has reached Level 3. User B has accumulated points = 360,000;',
    9100071: 'Then the cumulative promotion points that user A can obtain = 360000* 30% = 108,000',
    9100072: 'Reward coefficient ',
    9100073: '1 Trading users ',
    9100074: 'The trading volume reaches 5 million ',
    9100075: 'The trading volume reaches 20 million ',

    9100076: 'Transfer',

    //热币
    9100080: 'Ended',
    9100081: 'Click ‘Join Now’ to win rewards',
    9100082: 'View Rules',
    9100083: 'Join Now',
    9100084: 'Activity',
    9100088: 'Trade',
    9100089: 'Deposit',
    9100090: 'You have already registered',

    9100091: 'This event has ended, please look forward to the next event!',
    9100092: 'The event has not started yet, please stay tuned.',
    9100093: '',
    9100094: '',

    //自由区二维码分享页面
    9100095: 'SuperEx Free Market, a crypto world of the users, by the users, for the users',
    9100096: 'Open the app',
    9100097: '',
    9100098: '',
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/en.js